// import React, { useEffect, useState } from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import { URLS } from "../Url";
// import axios from "axios";
// import logo from "./logo1.png";
// import 'bootstrap/dist/js/bootstrap.bundle.min';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import {
//   FaPhoneAlt,
//   FaWhatsapp,
//   FaMobileAlt,
//   FaInstagram,
//   FaHome,
//   FaMapMarkerAlt,
//   FaBirthdayCake,
//   FaUser,
//   FaBars,
//   FaCompress,
//   FaExpand,
//   FaImage,
//   FaDollarSign,
//   FaCrown,
//   FaTicketAlt
// } from "react-icons/fa";

// function Header() {
//   const location = useLocation();
//   const [showMessage, setShowMessage] = useState(false);
//   const [show, setshow] = useState(false);
//   const [Contact, setContact] = useState([]);
//   const [PopUp, setPopUp] = useState([]);

//   const shows = show === true ? "menu-opened" : "";

//   useEffect(() => {
//     // Show message only on home page
//     if (location.pathname === "/") {
//       setShowMessage(true);
//       const timer = setTimeout(() => setShowMessage(false), 15000);
//       return () => clearTimeout(timer);
//     }
//   }, [location.pathname]);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [location.pathname]);

//   useEffect(() => {
//     GetFooterData();
//   }, []);

//   const GetFooterData = () => {
//     axios.post(URLS.GetFooter, {}, {}).then((res) => {
//       if (res.status === 200) {
//         setContact(res.data.contactus);
//         setPopUp(res.data.popup[0]);
//       }
//     });
//   };

//   const currentPage = () => {
//     const path = location.pathname === "/" ? "Home" : location.pathname.slice(1);
//     return path;
//   };

//   const [isFullScreen, setIsFullScreen] = useState(false);

//   const toggleFullScreen = () => {
//     if (!document.fullscreenElement) {
//       document.documentElement.requestFullscreen();
//       setIsFullScreen(true);
//     } else {
//       document.exitFullscreen();
//       setIsFullScreen(false);
//     }
//   };

//   return (
//     <>
//       <div className={shows}>
//         <header className="header main-header headersix">
//           <nav className="navbar navbar-expand-lg header-nav" style={{ backgroundColor: "#fff" }}>
//             <div className="navbar-header">

//               {/* MOBILE ONLY: Hamburger + Logo + Book/Icons row */}
//               <div className="d-flex d-md-none align-items-center justify-content-around w-100">

//                 {/* LEFT: Hamburger + Logo */}
//                 <div className="d-flex align-items-center gap-2">
//                   <button
//                     className="border-0 bg-transparent p-1"
//                     onClick={() => setshow(true)}
//                     aria-label="Open menu"
//                     style={{ lineHeight: 1 }}
//                   >
//                     <FaBars size={22} color="#800080" />
//                   </button>
//                   <a href="/" className="navbar-brand logo mb-0">
//                     <img src={logo} className="img-fluid" alt="Logo" style={{ height: "80px" }} />
//                   </a>
//                 </div>

//                 {/* RIGHT: Book Now + Icons */}
//                 <div className="d-flex flex-column align-items-end">
//                   {/*<a
//                     href="/locations"
//                     className="btn text-white book1-btn"
//                     style={{ padding: "6px 14px", fontSize: "13px", borderRadius: "10px", fontWeight: "600" }}
//                   >
//                     Book Now
//                   </a>*/}
//                   {/* Rewards Button */}
//                   <a
//                     href="/profile"
//                     className="d-flex align-items-center justify-content-center mt-2 text-decoration-none"
//                     style={{
//                       border: "2px solid #681DC0",
//                       borderRadius: "20px",
//                       padding: "5px 12px",
//                       background: "#F3E8FF",
//                       color: "#681DC0",
//                       fontSize: "13px",
//                       fontWeight: "600",
//                       gap: "6px",
//                     }}
//                   >
//                     <i className="bi bi-gift-fill"></i>
//                     Rewards
//                   </a>
//                   {/* <div className="d-flex gap-3 mt-2">
//                     <a href={Contact.instagram || "#"} target="_blank" rel="noreferrer">
//                       <FaInstagram size={18} color="#E1306C" />
//                     </a>
//                     <a href={`tel:${Contact.phone}`}>
//                       <FaPhoneAlt size={18} color="#800080" />
//                     </a>
//                     <a href="/profile">
//                       <FaUser size={18} color="#831cd2" />
//                     </a>
//                   </div> */}
//                 </div>
//               </div>

//               {/* DESKTOP ONLY: Just the logo */}
//               <a href="/" className="navbar-brand logo ms-1 d-none d-md-block">
//                 <img src={logo} className="img-fluid" alt="Logo" style={{ height: "80px", marginRight: "10px" }} />
//               </a>

//             </div>

//             <div className="main-menu-wrapper">
//               <div className="menu-header">
//                 <a href="/" className="menu-logo">
//                   <img src={logo} className="img-fluid" alt="Logo" />
//                 </a>
//                 <a id="menu_close" className="menu-close" onClick={() => setshow(false)}>
//                   <i className="fas fa-times" />
//                 </a>
//               </div>
//               <ul className="main-nav">
//                 <li><NavLink to="/" style={{ color: currentPage() === "Home" ? "#800080" : "" }} className="fw-bold">Home</NavLink></li>
//                 <li><NavLink to="/about" style={{ color: currentPage() === "about" ? "#800080" : "" }} className="fw-bold">About Us</NavLink></li>
//                 <li><NavLink to="/locations" style={{ color: currentPage() === "locations" ? "#800080" : "" }} className="fw-bold">THEATRES</NavLink></li>
//                 <li><NavLink to="/gallery" style={{ color: currentPage() === "gallery" ? "#800080" : "" }} className="fw-bold">Gallery</NavLink></li>
//                 <li><NavLink to="/cakes" style={{ color: currentPage() === "cakes" ? "#800080" : "" }} className="fw-bold">Cakes</NavLink></li>
//                 <li><NavLink to="/enquiry" style={{ color: currentPage() === "enquiry" ? "#800080" : "" }} className="fw-bold">GET QUOTE</NavLink></li>
//                 <li><NavLink to="/Reviews" style={{ color: currentPage() === "Reviews" ? "#800080" : "" }} className="fw-bold">Testimonials</NavLink></li>
//                 <li><NavLink to="/packages" style={{ color: currentPage() === "Packages" ? "#800080" : "" }} className="fw-bold">Plans</NavLink></li>
//                 <li><NavLink to="/profile" style={{ color: currentPage() === "profile" ? "#800080" : "" }} className="fw-bold">My Profile</NavLink></li>

//                 {/* Mobile Contact Icons - Only visible in mobile menu */}
//                 <li className="mobile-contact-header d-md-none" style={{
//                   borderTop: '1px solid #e0e0e0',
//                   marginTop: '15px',
//                   paddingTop: '15px'
//                 }}>
//                   <div style={{
//                     color: '#fff',
//                     fontSize: '13px',
//                     fontWeight: 'bold',
//                     textTransform: 'uppercase',
//                     marginBottom: '10px',
//                     paddingLeft: '15px'
//                   }}>
//                     Connect With Us
//                   </div>
//                 </li>
//                 <li className="mobile-contact-item d-md-none">
//                   <a
//                     href="https://www.instagram.com/carnival_castle_hyderabad/?hl=en"
//                     target="_blank"
//                     rel="noreferrer"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "12px",
//                       padding: "12px 15px",
//                       color: "#333",
//                       textDecoration: "none",
//                       borderBottom: "1px solid #f0f0f0"
//                     }}
//                     onClick={() => setshow(false)}
//                   >
//                     <FaInstagram color="#E1306C" size={20} />
//                     <span style={{ fontSize: "14px" }}>Instagram</span>
//                   </a>
//                 </li>
//                 <li className="mobile-contact-item d-md-none">
//                   <a
//                     href={`tel:8374777834`}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "12px",
//                       padding: "12px 15px",
//                       color: "#333",
//                       textDecoration: "none",
//                       borderBottom: "1px solid #f0f0f0"
//                     }}
//                     onClick={() => setshow(false)}
//                   >
//                     <FaPhoneAlt color="#40008C" size={20} />
//                     <span style={{ fontSize: "14px" }}>Call Us: +91 8374777834</span>
//                   </a>
//                 </li>
//                 <li className="mobile-contact-item d-md-none">
//                   <a
//                     href={`https://wa.me/918374777834`}
//                     target="_blank"
//                     rel="noreferrer"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "12px",
//                       padding: "12px 15px",
//                       color: "#333",
//                       textDecoration: "none",
//                       borderBottom: "1px solid #f0f0f0"
//                     }}
//                     onClick={() => setshow(false)}
//                   >
//                     <FaWhatsapp color="#25D366" size={20} />
//                     <span style={{ fontSize: "14px" }}>WhatsApp: +91 8374777834</span>
//                   </a>
//                 </li>
//                 <li className="mobile-contact-item d-md-none">
//                   <a
//                     href={`tel:${Contact.mobile || "8374777834"}`}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "12px",
//                       padding: "12px 15px",
//                       color: "#333",
//                       textDecoration: "none"
//                     }}
//                     onClick={() => setshow(false)}
//                   >
//                     <FaMobileAlt color="#40008C" size={20} />
//                     <span style={{ fontSize: "14px" }}>Mobile: +91 8374777834</span>
//                   </a>
//                 </li>
//               </ul>

//               {/* Desktop Contact Details */}
//               <div
//                 className="desktop-contact-details d-none d-lg-flex"
//                 style={{
//                   justifyContent: "center",
//                   gap: "40px",
//                   marginTop: "10px",
//                   padding: "10px 0",
//                   backgroundColor: "#9D4DFF",
//                   fontSize: "14px",
//                   borderRadius: "20px"
//                 }}
//               >

//                 {/* INSTAGRAM */}
//                 <a
//                   href="https://www.instagram.com/carnival_castle_hyderabad/?hl=en"
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     color: "#fff",
//                     textDecoration: "none",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     fontWeight: "700"
//                   }}
//                 >
//                   <span
//                     style={{
//                       background: "#fff",
//                       borderRadius: "50%",
//                       width: "30px",
//                       height: "30px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center"
//                     }}
//                   >
//                     <FaInstagram color="#dc2743" size={16} />
//                   </span>
//                   <span>carnival_castle_hyderabad</span>
//                 </a>

//                 {/* PHONE */}
//                 <a
//                   href="tel:8341428342"
//                   style={{
//                     color: "#fff",
//                     textDecoration: "none",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     fontWeight: "700"
//                   }}
//                 >
//                   <span
//                     style={{
//                       background: "#fff",
//                       borderRadius: "50%",
//                       width: "30px",
//                       height: "30px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center"
//                     }}
//                   >
//                     <FaPhoneAlt color="#4b50f2" size={14} />
//                   </span>
//                   <span>+91 8341428342</span>
//                 </a>

//                 {/* WHATSAPP */}
//                 <a
//                   href="https://wa.me/918374777834"
//                   target="_blank"
//                   rel="noreferrer"
//                   style={{
//                     color: "#fff",
//                     textDecoration: "none",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     fontWeight: "700"
//                   }}
//                 >
//                   <span
//                     style={{
//                       background: "#fff",
//                       borderRadius: "50%",
//                       width: "30px",
//                       height: "30px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center"
//                     }}
//                   >
//                     <FaWhatsapp color="#2cde5b" size={16} />
//                   </span>
//                   <span>+91 8374777834</span>
//                 </a>

//               </div>
//             </div>

//             <ul className="nav header-navbar-rht book-now-btn d-none d-lg-block">
//               <li className="nav-item contact-item">
//                 <a href="/locations" className="btn text-white book1-btn">Book Now</a>
//               </li>
//             </ul>
//           </nav>
//         </header>

//         {/* --- MOBILE BOTTOM NAVIGATION --- */}
//         <div className="mobile-bottom-nav d-lg-none">
//           <NavLink to="/" className="nav-item">
//             <FaHome size={20} />
//             <span>Home</span>
//           </NavLink>
//           <NavLink to="/gallery" className="nav-item">
//             <FaImage size={20} />
//             <span>Gallery</span>
//           </NavLink>
//           <div className="nav-item book-special" onClick={() => window.location.href = '/locations'}>
//             <div className="inner-book">
//               <FaTicketAlt size={20} color="#fff" />
//             </div>
//             <span style={{ fontSize: "10px", fontWeight: 600, color: "#800080", marginTop: "2px" }}>Book Now</span>
//           </div>
//           <NavLink to="/cakes" className="nav-item">
//             <FaBirthdayCake size={20} />
//             <span>Addons</span>
//           </NavLink>
//           <NavLink to="/packages" className="nav-item">
//             <FaCrown size={20} />
//             <span>Plans</span>
//           </NavLink>
//         </div>

//         {/* Floating Actions */}
//         <div className="cp-floating-area">
//           <div className="cp-floating-action">
//             {/* FULLSCREEN TOGGLE */}
//             <button onClick={toggleFullScreen} className="sbutton fullscreen">
//               {isFullScreen ? (
//                 <FaCompress size={20} color="white" />
//               ) : (
//                 <FaExpand size={20} color="white" />
//               )}
//             </button>
//             <a href="tel:+918341428342" className="sbutton phone"><FaPhoneAlt size={22} color="white" /></a>
//             <a href="https://wa.me/918374777834" className="sbutton whatsapp"><FaWhatsapp size={22} color="white" /></a>
//             {showMessage && <div className="floating-msg">How can I assist you?</div>}
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         /* Mobile Bottom Nav Styles */

//         .book1-btn {
//   background-color: #9D4DFF;
//   transition: all 0.3s ease;
//   border-radius: 8px;
// }

// .book1-btn:hover {
//   background-color: #7a2df5;
//   transform: translateY(-2px);
//   box-shadow: 0 6px 14px rgba(157, 77, 255, 0.35);
// }
//         .mobile-bottom-nav {
//           position: fixed;
//           bottom: 0;
//           left: 0;
//           right: 0;
//           height: 65px;
//           background: #fff;
//           display: flex;
//           justify-content: space-around;
//           align-items: center;
//           box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
//           z-index: 1000;
//           padding-bottom: env(safe-area-inset-bottom);
//         }

//         .mobile-bottom-nav .nav-item {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           color: #666;
//           text-decoration: none;
//           font-size: 11px;
//           font-weight: 500;
//         }

//         .mobile-bottom-nav .nav-item.active {
//           color: #800080;
//         }

//         .book-special {
//           margin-top: -30px;
//         }

//         .inner-book {
//           background: #800080;
//           color: white;
//           width: 55px;
//           height: 55px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: bold;
//           box-shadow: 0 4px 10px rgba(128, 0, 128, 0.4);
//           border: 4px solid #fff;
//         }

//         /* Adjustments for Floating Area so it doesn't overlap bottom nav */
//         .cp-floating-area {
//           position: fixed;
//           bottom: 80px; /* Moved up to clear bottom bar */
//           right: 20px;
//           z-index: 999;
//         }

//         .sbutton {
//           width: 50px;
//           height: 50px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 10px;
//           text-decoration: none;
//         }
//         .phone { background: #242724; }
//         .whatsapp { background: #25D366; }
//         .fullscreen { background: #924ae9; }

//         .floating-msg {
//           position: absolute;
//           right: 60px;
//           bottom: 10px;
//           background: white;
//           padding: 8px 15px;
//           border-radius: 8px;
//           box-shadow: 0 2px 10px rgba(0,0,0,0.1);
//           white-space: nowrap;
//           font-size: 13px;
//         }

//         /* Mobile Contact Items Hover Effect */
//         .mobile-contact-item a:hover {
//           background-color: #f8f8f8;
//         }

//         @media (max-width: 991px) {
//           body { padding-bottom: 70px; } /* Prevent content being hidden behind bar */
//           .header-nav { padding: 10px 0; }
          
//           /* Ensure main-nav has proper spacing for contact items */
//           .main-nav {
//             padding-bottom: 20px;
//           }
//         }
//       `}</style>
//     </>
//   );
// }

// export default Header;  

// import React, { useEffect, useState, useRef } from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import { URLS } from "../Url";
// import axios from "axios";
// import logo from "./logo1.png";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import "bootstrap/dist/css/bootstrap.min.css";
// import {
//   FaPhoneAlt, FaWhatsapp, FaMobileAlt, FaInstagram,
//   FaHome, FaMapMarkerAlt, FaBirthdayCake, FaUser,
//   FaBars, FaCompress, FaExpand, FaImage, FaDollarSign,
//   FaCrown, FaTicketAlt, FaTimes, FaChevronDown,
// } from "react-icons/fa";

// /* ─── Brand tokens ──────────────────────────────────────────────────────── */
// const B = {
//   purple:  "#5E0E73",
//   purpleL: "#7B1A94",
//   purpleD: "#3A0847",
//   gold:    "#C9A84C",
//   goldL:   "#E8D5A0",
//   goldB:   "#F5D87A",
//   dark:    "#1A0030",
//   cream:   "#E8E1D6",
//   white:   "#FFFFFF",
// };

// const NAV_LINKS = [
//   { to: "/",          label: "Home",        icon: "🏠" },
//   { to: "/about",     label: "About Us",    icon: "✨" },
//   { to: "/locations", label: "Theatres",    icon: "🎬" },
//   { to: "/gallery",   label: "Gallery",     icon: "📸" },
//   { to: "/cakes",     label: "Cakes",       icon: "🎂" },
//   { to: "/enquiry",   label: "Get Quote",   icon: "💬" },
//   { to: "/Reviews",   label: "Testimonials",icon: "⭐" },
//   { to: "/packages",  label: "Plans",       icon: "👑" },
//   { to: "/profile",   label: "My Profile",  icon: "🎪" },
// ];

// const BOTTOM_NAV = [
//   { to: "/",         label: "Home",    icon: FaHome },
//   { to: "/gallery",  label: "Gallery", icon: FaImage },
//   { to: "/cakes",    label: "Addons",  icon: FaBirthdayCake },
//   { to: "/packages", label: "Plans",   icon: FaCrown },
// ];

// /* ══════════════════════════════════════════════════════════════════════════ */
// function Header() {
//   const location   = useLocation();
//   const [drawerOpen, setDrawerOpen]     = useState(false);
//   const [scrolled,   setScrolled]       = useState(false);
//   const [showMsg,    setShowMsg]        = useState(false);
//   const [isFS,       setIsFS]           = useState(false);
//   const [Contact,    setContact]        = useState({});
//   const drawerRef = useRef(null);

//   /* scroll detection */
//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 40);
//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   /* close drawer on route change */
//   useEffect(() => {
//     setDrawerOpen(false);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [location.pathname]);

//   /* floating message on home */
//   useEffect(() => {
//     if (location.pathname === "/") {
//       setShowMsg(true);
//       const t = setTimeout(() => setShowMsg(false), 15000);
//       return () => clearTimeout(t);
//     }
//   }, [location.pathname]);

//   /* fetch contact */
//   useEffect(() => {
//     axios.post(URLS.GetFooter, {}).then(r => {
//       if (r.status === 200) setContact(r.data.contactus?.[0] || {});
//     }).catch(() => {});
//   }, []);

//   /* close drawer on outside click */
//   useEffect(() => {
//     const handler = e => {
//       if (drawerOpen && drawerRef.current && !drawerRef.current.contains(e.target)) {
//         setDrawerOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, [drawerOpen]);

//   /* lock body scroll when drawer open */
//   useEffect(() => {
//     document.body.style.overflow = drawerOpen ? "hidden" : "";
//     return () => { document.body.style.overflow = ""; };
//   }, [drawerOpen]);

//   const toggleFS = () => {
//     if (!document.fullscreenElement) {
//       document.documentElement.requestFullscreen();
//       setIsFS(true);
//     } else {
//       document.exitFullscreen();
//       setIsFS(false);
//     }
//   };

//   const isActive = (to) =>
//     to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

//   return (
//     <>
//       {/* ══════════════ STYLES ══════════════════════════════════════ */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@400;500;600;700&display=swap');

//         :root {
//           --hp: ${B.purple}; --hpl: ${B.purpleL}; --hpd: ${B.purpleD};
//           --hg: ${B.gold}; --hgl: ${B.goldL}; --hgb: ${B.goldB};
//           --hdk: ${B.dark}; --hcr: ${B.cream};
//         }

//         /* ── Top contact bar ── */
//         .hdr-topbar {
//           background: linear-gradient(135deg, var(--hpd) 0%, var(--hp) 60%, var(--hpd) 100%);
//           padding: 7px 0;
//           overflow: hidden;
//           position: relative;
//           border-bottom: 1px solid rgba(201,168,76,.2);
//         }
//         .hdr-topbar::before {
//           content: '';
//           position: absolute; inset: 0;
//           background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.03'%3E%3Cpath d='M20 20v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
//           pointer-events: none;
//         }
//         .hdr-topbar-inner {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           flex-wrap: wrap;
//           gap: 8px;
//           position: relative;
//           z-index: 1;
//         }
//         .hdr-topbar-left {
//           display: flex;
//           align-items: center;
//           gap: 6px;
//           font-size: 12px;
//           color: rgba(255,255,255,.75);
//           font-family: 'DM Sans', sans-serif;
//           font-weight: 500;
//         }
//         .hdr-topbar-left span {
//           background: rgba(201,168,76,.18);
//           border: 1px solid rgba(201,168,76,.3);
//           border-radius: 60px;
//           padding: 3px 12px;
//           font-size: 11px;
//           color: ${B.goldL};
//           font-weight: 700;
//           letter-spacing: .5px;
//         }
//         .hdr-topbar-contacts {
//           display: flex;
//           align-items: center;
//           gap: 20px;
//         }
//         .hdr-tc-link {
//           display: flex;
//           align-items: center;
//           gap: 7px;
//           color: rgba(255,255,255,.85);
//           text-decoration: none;
//           font-size: 12px;
//           font-family: 'DM Sans', sans-serif;
//           font-weight: 600;
//           transition: color .2s;
//         }
//         .hdr-tc-link:hover { color: ${B.goldL}; }
//         .hdr-tc-icon {
//           width: 24px; height: 24px; border-radius: 50%;
//           background: rgba(255,255,255,.12);
//           display: flex; align-items: center; justify-content: center;
//           flex-shrink: 0;
//           transition: background .2s;
//         }
//         .hdr-tc-link:hover .hdr-tc-icon { background: rgba(201,168,76,.25); }

//         /* ── Main navbar ── */
//         .hdr-main {
//           position: sticky;
//           top: 0;
//           z-index: 999;
//           background: rgba(255,255,255,0.97);
//           border-bottom: 1px solid rgba(94,14,115,.08);
//           transition: box-shadow .35s, background .35s, backdrop-filter .35s;
//           font-family: 'DM Sans', sans-serif;
//         }
//         .hdr-main.scrolled {
//           background: rgba(255,255,255,0.88);
//           backdrop-filter: blur(20px);
//           -webkit-backdrop-filter: blur(20px);
//           box-shadow: 0 4px 32px rgba(94,14,115,.12);
//           border-bottom-color: rgba(201,168,76,.2);
//         }
//         .hdr-main-inner {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           height: 70px;
//           gap: 16px;
//         }

//         /* Logo */
//         .hdr-logo {
//           flex-shrink: 0;
//           display: flex;
//           align-items: center;
//           text-decoration: none;
//           gap: 10px;
//         }
//         .hdr-logo img {
//           height: 52px;
//           width: auto;
//           display: block;
//           transition: transform .3s;
//         }
//         .hdr-logo:hover img { transform: scale(1.04); }

//         /* Desktop Nav Links */
//         .hdr-nav-links {
//           display: flex;
//           align-items: center;
//           gap: 2px;
//           list-style: none;
//           margin: 0; padding: 0;
//           flex: 1;
//           justify-content: center;
//         }
//         .hdr-nav-links li a {
//           display: inline-flex;
//           align-items: center;
//           padding: 8px 13px;
//           font-size: 13px;
//           font-weight: 600;
//           color: #444;
//           text-decoration: none;
//           border-radius: 10px;
//           position: relative;
//           transition: color .25s, background .25s;
//           letter-spacing: .2px;
//           white-space: nowrap;
//         }
//         .hdr-nav-links li a::after {
//           content: '';
//           position: absolute;
//           bottom: 4px; left: 50%;
//           width: 0; height: 2px;
//           background: linear-gradient(90deg, var(--hp), var(--hg));
//           border-radius: 2px;
//           transform: translateX(-50%);
//           transition: width .3s cubic-bezier(.25,1,.5,1);
//         }
//         .hdr-nav-links li a:hover { color: var(--hp); background: rgba(94,14,115,.05); }
//         .hdr-nav-links li a:hover::after { width: 60%; }
//         .hdr-nav-links li a.active {
//           color: var(--hp);
//           background: rgba(94,14,115,.07);
//           font-weight: 700;
//         }
//         .hdr-nav-links li a.active::after { width: 65%; }

//         /* Desktop right area */
//         .hdr-right {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           flex-shrink: 0;
//         }
//         .hdr-rewards-btn {
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           background: linear-gradient(135deg, rgba(94,14,115,.08), rgba(94,14,115,.04));
//           border: 1.5px solid rgba(94,14,115,.2);
//           border-radius: 60px;
//           padding: 7px 16px;
//           color: var(--hp);
//           font-size: 12px;
//           font-weight: 700;
//           text-decoration: none;
//           transition: all .3s;
//           letter-spacing: .3px;
//         }
//         .hdr-rewards-btn:hover {
//           background: var(--hp);
//           color: #fff;
//           border-color: var(--hp);
//           transform: translateY(-1px);
//           box-shadow: 0 6px 18px rgba(94,14,115,.3);
//         }

//         /* Book Now CTA */
//         .hdr-book-btn {
//           position: relative;
//           overflow: hidden;
//           display: inline-flex;
//           align-items: center;
//           gap: 7px;
//           background: linear-gradient(135deg, #B8860B, var(--hg), var(--hgb), var(--hg), #9A6E10);
//           background-size: 200% 200%;
//           animation: hdrGold 3s ease infinite;
//           color: var(--hdk);
//           border: none;
//           border-radius: 60px;
//           padding: 10px 22px;
//           font-size: 13px;
//           font-weight: 800;
//           cursor: pointer;
//           text-decoration: none;
//           transition: transform .3s, box-shadow .3s;
//           box-shadow: 0 5px 18px rgba(201,168,76,.4);
//           font-family: 'DM Sans', sans-serif;
//           letter-spacing: .3px;
//           white-space: nowrap;
//         }
//         .hdr-book-btn::before {
//           content: '';
//           position: absolute; top: 0; left: -100%;
//           width: 55%; height: 100%;
//           background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
//           animation: hdrShine 3s ease infinite;
//         }
//         .hdr-book-btn:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 28px rgba(201,168,76,.55);
//           color: var(--hdk);
//         }
//         @keyframes hdrGold  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
//         @keyframes hdrShine { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
//         @keyframes hdrFade  { from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)} }
//         @keyframes hdrSlide { from{transform:translateX(-100%)}to{transform:translateX(0)} }
//         @keyframes hdrPulse { 0%,100%{box-shadow:0 0 0 0 rgba(201,168,76,.4)}50%{box-shadow:0 0 0 8px rgba(201,168,76,0)} }

//         /* ── MOBILE TOP BAR ── */
//         .hdr-mobile-bar {
//           display: none;
//           height: 64px;
//           align-items: center;
//           justify-content: space-between;
//           padding: 0 16px;
//         }
//         @media(max-width:991px) {
//           .hdr-main-inner { display: none; }
//           .hdr-mobile-bar { display: flex; }
//           .hdr-topbar { display: none; }
//         }
//         .hdr-mob-hamburger {
//           width: 40px; height: 40px;
//           border-radius: 12px;
//           background: rgba(94,14,115,.08);
//           border: 1.5px solid rgba(94,14,115,.15);
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 5px; cursor: pointer;
//           transition: all .25s; flex-shrink: 0;
//         }
//         .hdr-mob-hamburger:hover { background: var(--hp); border-color: var(--hp); }
//         .hdr-mob-hamburger:hover .hdr-ham-line { background: #fff; }
//         .hdr-ham-line { width: 20px; height: 2px; background: var(--hp); border-radius: 2px; transition: background .25s; }

//         .hdr-mob-right {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }
//         .hdr-mob-rewards {
//           display: inline-flex;
//           align-items: center;
//           gap: 5px;
//           background: rgba(94,14,115,.07);
//           border: 1.5px solid rgba(94,14,115,.2);
//           border-radius: 60px;
//           padding: 6px 13px;
//           color: var(--hp);
//           font-size: 12px;
//           font-weight: 700;
//           text-decoration: none;
//         }
//         .hdr-mob-book {
//           display: inline-flex;
//           align-items: center;
//           gap: 5px;
//           background: linear-gradient(135deg, var(--hp), var(--hpl));
//           color: #fff;
//           border: none;
//           border-radius: 60px;
//           padding: 7px 16px;
//           font-size: 12px;
//           font-weight: 700;
//           cursor: pointer;
//           text-decoration: none;
//           box-shadow: 0 4px 12px rgba(94,14,115,.3);
//           font-family: 'DM Sans', sans-serif;
//         }

//         /* ── DRAWER OVERLAY ── */
//         .hdr-overlay {
//           position: fixed; inset: 0; z-index: 1400;
//           background: rgba(10,0,20,.55);
//           backdrop-filter: blur(4px);
//           opacity: 0; pointer-events: none;
//           transition: opacity .35s;
//         }
//         .hdr-overlay.open { opacity: 1; pointer-events: all; }

//         /* ── DRAWER ── */
//         .hdr-drawer {
//           position: fixed;
//           top: 0; left: 0; bottom: 0;
//           width: min(340px, 88vw);
//           z-index: 1500;
//           background: #fff;
//           transform: translateX(-100%);
//           transition: transform .38s cubic-bezier(.25,1,.5,1);
//           display: flex;
//           flex-direction: column;
//           overflow: hidden;
//           box-shadow: 8px 0 60px rgba(94,14,115,.2);
//         }
//         .hdr-drawer.open {
//           transform: translateX(0);
//         }

//         /* Drawer header */
//         .hdr-drawer-head {
//           background: linear-gradient(135deg, var(--hpd) 0%, var(--hp) 100%);
//           padding: 24px 20px 20px;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           flex-shrink: 0;
//           position: relative;
//           overflow: hidden;
//         }
//         .hdr-drawer-head::before {
//           content: '';
//           position: absolute; inset: 0;
//           background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
//           pointer-events: none;
//         }
//         .hdr-drawer-logo { height: 48px; width: auto; position: relative; z-index: 1; }
//         .hdr-drawer-close {
//           width: 36px; height: 36px; border-radius: 50%;
//           background: rgba(255,255,255,.15);
//           border: 1.5px solid rgba(255,255,255,.25);
//           display: flex; align-items: center; justify-content: center;
//           cursor: pointer; color: #fff; font-size: 16px;
//           transition: all .25s; position: relative; z-index: 1;
//         }
//         .hdr-drawer-close:hover { background: rgba(255,255,255,.28); }

//         /* Drawer gold strip */
//         .hdr-drawer-gold {
//           background: linear-gradient(135deg, #B8860B, var(--hg), var(--hgb), var(--hg));
//           background-size: 200% 200%;
//           animation: hdrGold 3s ease infinite;
//           padding: 10px 20px;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           flex-shrink: 0;
//         }
//         .hdr-drawer-gold-text {
//           font-size: 12px;
//           font-weight: 800;
//           color: var(--hdk);
//           letter-spacing: .5px;
//         }
//         .hdr-drawer-gold-code {
//           background: rgba(0,0,0,.18);
//           border-radius: 6px;
//           padding: 3px 10px;
//           font-size: 11px;
//           font-weight: 800;
//           color: var(--hdk);
//           font-family: monospace;
//           letter-spacing: 1px;
//         }

//         /* Drawer nav list */
//         .hdr-drawer-nav {
//           flex: 1;
//           overflow-y: auto;
//           padding: 12px 0;
//         }
//         .hdr-drawer-nav::-webkit-scrollbar { width: 3px; }
//         .hdr-drawer-nav::-webkit-scrollbar-thumb { background: rgba(94,14,115,.2); border-radius: 2px; }

//         .hdr-dlink {
//           display: flex;
//           align-items: center;
//           gap: 14px;
//           padding: 13px 20px;
//           color: #333;
//           text-decoration: none;
//           font-family: 'DM Sans', sans-serif;
//           font-size: 14px;
//           font-weight: 600;
//           transition: all .22s;
//           position: relative;
//           border-bottom: 1px solid rgba(94,14,115,.04);
//         }
//         .hdr-dlink:hover { background: rgba(94,14,115,.05); color: var(--hp); padding-left: 26px; }
//         .hdr-dlink.active { background: rgba(94,14,115,.07); color: var(--hp); }
//         .hdr-dlink.active::before {
//           content: '';
//           position: absolute; left: 0; top: 0; bottom: 0;
//           width: 3px;
//           background: linear-gradient(180deg, var(--hp), var(--hg));
//           border-radius: 0 2px 2px 0;
//         }
//         .hdr-dlink-icon {
//           width: 38px; height: 38px;
//           border-radius: 12px;
//           background: rgba(94,14,115,.07);
//           display: flex; align-items: center; justify-content: center;
//           font-size: 17px;
//           flex-shrink: 0;
//           transition: background .22s;
//         }
//         .hdr-dlink:hover .hdr-dlink-icon,
//         .hdr-dlink.active .hdr-dlink-icon {
//           background: linear-gradient(135deg, var(--hp), var(--hpl));
//           font-size: 17px;
//         }
//         .hdr-dlink-arrow {
//           margin-left: auto;
//           font-size: 11px;
//           color: rgba(94,14,115,.3);
//           transition: color .22s, transform .22s;
//         }
//         .hdr-dlink:hover .hdr-dlink-arrow { color: var(--hp); transform: translateX(3px); }

//         /* Drawer section label */
//         .hdr-dsection {
//           font-size: 10px;
//           font-weight: 800;
//           letter-spacing: 2px;
//           text-transform: uppercase;
//           color: rgba(94,14,115,.45);
//           padding: 16px 20px 6px;
//           font-family: 'DM Sans', sans-serif;
//         }

//         /* Drawer contact items */
//         .hdr-dcontact {
//           display: flex;
//           align-items: center;
//           gap: 14px;
//           padding: 12px 20px;
//           color: #444;
//           text-decoration: none;
//           font-family: 'DM Sans', sans-serif;
//           font-size: 13px;
//           font-weight: 500;
//           border-bottom: 1px solid rgba(94,14,115,.04);
//           transition: background .2s;
//         }
//         .hdr-dcontact:hover { background: rgba(94,14,115,.04); }
//         .hdr-dcontact-icon {
//           width: 36px; height: 36px; border-radius: 10px;
//           display: flex; align-items: center; justify-content: center;
//           flex-shrink: 0;
//         }

//         /* Drawer footer */
//         .hdr-drawer-footer {
//           padding: 16px 20px;
//           border-top: 1px solid rgba(94,14,115,.08);
//           flex-shrink: 0;
//         }
//         .hdr-dfooter-book {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           width: 100%;
//           padding: 14px;
//           background: linear-gradient(135deg, var(--hp), var(--hpl));
//           color: #fff;
//           border: none;
//           border-radius: 16px;
//           font-size: 15px;
//           font-weight: 800;
//           cursor: pointer;
//           text-decoration: none;
//           box-shadow: 0 8px 24px rgba(94,14,115,.35);
//           transition: all .3s;
//           font-family: 'DM Sans', sans-serif;
//         }
//         .hdr-dfooter-book:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 12px 32px rgba(94,14,115,.45);
//           color: #fff;
//         }
//         .hdr-dfooter-sub {
//           text-align: center;
//           font-size: 11px;
//           color: #aaa;
//           margin-top: 8px;
//           font-family: 'DM Sans', sans-serif;
//         }

//         /* ── MOBILE BOTTOM NAV ── */
//         .hdr-bottom-nav {
//           position: fixed;
//           bottom: 0; left: 0; right: 0;
//           height: 62px;
//           background: rgba(255,255,255,.96);
//           backdrop-filter: blur(16px);
//           -webkit-backdrop-filter: blur(16px);
//           border-top: 1px solid rgba(94,14,115,.1);
//           display: none;
//           justify-content: space-around;
//           align-items: center;
//           z-index: 1000;
//           padding-bottom: env(safe-area-inset-bottom, 0px);
//           box-shadow: 0 -4px 24px rgba(94,14,115,.08);
//         }
//         @media(max-width:991px) { .hdr-bottom-nav { display: flex; } }

//         .hdr-bnav-item {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 3px;
//           color: #999;
//           text-decoration: none;
//           font-size: 10px;
//           font-weight: 600;
//           font-family: 'DM Sans', sans-serif;
//           transition: color .25s;
//           padding: 6px 12px;
//           border-radius: 14px;
//           min-width: 56px;
//         }
//         .hdr-bnav-item:hover { color: var(--hp); }
//         .hdr-bnav-item.active { color: var(--hp); }
//         .hdr-bnav-icon {
//           width: 28px; height: 28px;
//           display: flex; align-items: center; justify-content: center;
//           border-radius: 10px;
//           transition: background .25s, transform .25s;
//           font-size: 17px;
//         }
//         .hdr-bnav-item.active .hdr-bnav-icon {
//           background: rgba(94,14,115,.1);
//           transform: translateY(-1px);
//         }

//         /* Center Book button */
//         .hdr-bnav-center {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 3px;
//           cursor: pointer;
//           margin-top: -22px;
//         }
//         .hdr-bnav-center-inner {
//           width: 54px; height: 54px;
//           border-radius: 50%;
//           background: linear-gradient(135deg, var(--hp), var(--hpl));
//           display: flex; align-items: center; justify-content: center;
//           box-shadow: 0 6px 20px rgba(94,14,115,.45);
//           border: 3px solid #fff;
//           transition: all .3s;
//           animation: hdrPulse 2.5s ease-in-out infinite;
//         }
//         .hdr-bnav-center:hover .hdr-bnav-center-inner {
//           transform: scale(1.08);
//           box-shadow: 0 10px 28px rgba(94,14,115,.55);
//         }
//         .hdr-bnav-center span {
//           font-size: 10px; font-weight: 700;
//           color: var(--hp); font-family: 'DM Sans', sans-serif;
//           margin-top: 2px;
//         }

//         /* ── FLOATING ACTIONS ── */
//         .hdr-floating {
//           position: fixed;
//           bottom: 80px; right: 18px;
//           z-index: 998;
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//           align-items: center;
//         }
//         @media(max-width:991px) { .hdr-floating { bottom: 80px; } }
//         .hdr-fab {
//           width: 48px; height: 48px;
//           border-radius: 50%;
//           display: flex; align-items: center; justify-content: center;
//           text-decoration: none;
//           border: none;
//           cursor: pointer;
//           transition: all .3s;
//           box-shadow: 0 4px 14px rgba(0,0,0,.2);
//         }
//         .hdr-fab:hover { transform: translateY(-3px) scale(1.08); }
//         .hdr-fab-fs     { background: var(--hp); }
//         .hdr-fab-phone  { background: #242724; }
//         .hdr-fab-wa     { background: #25D366; }
//         .hdr-fab-wa:hover { box-shadow: 0 6px 20px rgba(37,211,102,.4); }
//         .hdr-fab-phone:hover { box-shadow: 0 6px 20px rgba(36,39,36,.4); }
//         .hdr-fab-fs:hover { box-shadow: 0 6px 20px rgba(94,14,115,.4); }

//         .hdr-floating-msg {
//           position: absolute;
//           right: 58px; bottom: 4px;
//           background: #fff;
//           padding: 7px 14px;
//           border-radius: 10px;
//           box-shadow: 0 4px 16px rgba(0,0,0,.1);
//           white-space: nowrap;
//           font-size: 12px;
//           font-weight: 600;
//           color: #333;
//           font-family: 'DM Sans', sans-serif;
//           border: 1px solid rgba(94,14,115,.1);
//           animation: hdrFade .4s ease both;
//         }
//         .hdr-floating-msg::after {
//           content: '';
//           position: absolute; right: -7px; top: 50%;
//           transform: translateY(-50%);
//           border: 6px solid transparent;
//           border-left-color: #fff;
//         }

//         /* ── Responsive hide/show ── */
//         @media(min-width:992px) {
//           .hdr-mob-only { display: none !important; }
//         }
//         @media(max-width:991px) {
//           .hdr-desk-only { display: none !important; }
//           body { padding-bottom: 68px; }
//         }

//         /* Adjust so nav underline works with NavLink active */
//         .hdr-nav-links li a.active-link { color: var(--hp) !important; background: rgba(94,14,115,.07) !important; font-weight: 700 !important; }
//         .hdr-nav-links li a.active-link::after { width: 65% !important; }
//       `}</style>

//       {/* ══ TOP CONTACT BAR (desktop only) ══════════════════════════ */}
//       <div className="hdr-topbar hdr-desk-only">
//         <div className="container">
//           <div className="hdr-topbar-inner">
//             <div className="hdr-topbar-left">
//               <span>🎉 Book Now</span>
//               <span style={{ fontSize:12, color:"rgba(255,255,255,.6)", background:"none", border:"none", padding:0 }}>& get up to 40% off with code</span>
//               <span>CASTLE10</span>
//             </div>
//             <div className="hdr-topbar-contacts">
//               <a href="https://www.instagram.com/carnival_castle_hyderabad/" target="_blank" rel="noreferrer" className="hdr-tc-link">
//                 <span className="hdr-tc-icon"><FaInstagram color="#E1306C" size={12} /></span>
//                 carnival_castle_hyderabad
//               </a>
//               <a href="tel:8341428342" className="hdr-tc-link">
//                 <span className="hdr-tc-icon"><FaPhoneAlt color={B.gold} size={11} /></span>
//                 +91 8341428342
//               </a>
//               <a href="https://wa.me/918374777834" target="_blank" rel="noreferrer" className="hdr-tc-link">
//                 <span className="hdr-tc-icon"><FaWhatsapp color="#25D366" size={13} /></span>
//                 +91 8374777834
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ══ MAIN NAVBAR ══════════════════════════════════════════════ */}
//       <header className={`hdr-main${scrolled ? " scrolled" : ""}`}>
//         {/* ── Desktop ── */}
//         <div className="container hdr-desk-only">
//           <div className="hdr-main-inner">
//             <a href="/" className="hdr-logo">
//               <img src={logo} alt="Carnival Castle" />
//             </a>

//             <ul className="hdr-nav-links">
//               {NAV_LINKS.slice(0, 8).map(({ to, label }) => (
//                 <li key={to}>
//                   <NavLink
//                     to={to}
//                     className={({ isActive }) => isActive ? "active-link" : ""}
//                     end={to === "/"}
//                   >
//                     {label}
//                   </NavLink>
//                 </li>
//               ))}
//             </ul>

//             <div className="hdr-right">
//               <a href="/profile" className="hdr-rewards-btn">
//                 <i className="bi bi-gift-fill" style={{ fontSize:13 }} />
//                 Rewards
//               </a>
//               <a href="/locations" className="hdr-book-btn">
//                 🎉 Book Now
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* ── Mobile top bar ── */}
//         <div className="hdr-mobile-bar hdr-mob-only">
//           <button className="hdr-mob-hamburger" onClick={() => setDrawerOpen(true)} aria-label="Open menu">
//             <div className="hdr-ham-line" />
//             <div className="hdr-ham-line" />
//             <div className="hdr-ham-line" style={{ width:14 }} />
//           </button>

//           <a href="/" className="hdr-logo">
//             <img src={logo} alt="Carnival Castle" style={{ height:46 }} />
//           </a>

//           <div className="hdr-mob-right">
//             <a href="/profile" className="hdr-mob-rewards">
//               <i className="bi bi-gift-fill" style={{ fontSize:12 }} />
//               Rewards
//             </a>
//             <a href="/locations" className="hdr-mob-book">
//               🎉 Book
//             </a>
//           </div>
//         </div>
//       </header>

//       {/* ══ DRAWER OVERLAY ═══════════════════════════════════════════ */}
//       <div className={`hdr-overlay hdr-mob-only${drawerOpen ? " open" : ""}`} onClick={() => setDrawerOpen(false)} />

//       {/* ══ DRAWER ═══════════════════════════════════════════════════ */}
//       <aside ref={drawerRef} className={`hdr-drawer hdr-mob-only${drawerOpen ? " open" : ""}`} aria-hidden={!drawerOpen}>
//         {/* Header */}
//         <div className="hdr-drawer-head">
//           <img src={logo} alt="Logo" className="hdr-drawer-logo" />
//           <button className="hdr-drawer-close" onClick={() => setDrawerOpen(false)} aria-label="Close menu">
//             <FaTimes size={14} />
//           </button>
//         </div>

//         {/* Gold promo strip */}
//         <div className="hdr-drawer-gold">
//           <span className="hdr-drawer-gold-text">🎁 Up to 40% OFF Today</span>
//           <span className="hdr-drawer-gold-code">CASTLE10</span>
//         </div>

//         {/* Nav links */}
//         <nav className="hdr-drawer-nav">
//           <div className="hdr-dsection">Navigation</div>
//           {NAV_LINKS.map(({ to, label, icon }) => (
//             <NavLink
//               key={to}
//               to={to}
//               end={to === "/"}
//               className={({ isActive }) => `hdr-dlink${isActive ? " active" : ""}`}
//               onClick={() => setDrawerOpen(false)}
//             >
//               <div className="hdr-dlink-icon">{icon}</div>
//               <span>{label}</span>
//               <span className="hdr-dlink-arrow">›</span>
//             </NavLink>
//           ))}

//           {/* Connect section */}
//           <div className="hdr-dsection" style={{ marginTop:8 }}>Connect With Us</div>

//           <a href="https://www.instagram.com/carnival_castle_hyderabad/" target="_blank" rel="noreferrer"
//             className="hdr-dcontact" onClick={() => setDrawerOpen(false)}>
//             <div className="hdr-dcontact-icon" style={{ background:"rgba(225,48,108,.1)" }}>
//               <FaInstagram color="#E1306C" size={17} />
//             </div>
//             <div>
//               <div style={{ fontSize:13, fontWeight:700, color:"#222" }}>Instagram</div>
//               <div style={{ fontSize:11, color:"#888" }}>@carnival_castle_hyderabad</div>
//             </div>
//           </a>

//           <a href="tel:8374777834" className="hdr-dcontact" onClick={() => setDrawerOpen(false)}>
//             <div className="hdr-dcontact-icon" style={{ background:"rgba(94,14,115,.08)" }}>
//               <FaPhoneAlt color={B.purple} size={15} />
//             </div>
//             <div>
//               <div style={{ fontSize:13, fontWeight:700, color:"#222" }}>Call Us</div>
//               <div style={{ fontSize:11, color:"#888" }}>+91 8374777834</div>
//             </div>
//           </a>

//           <a href="https://wa.me/918374777834" target="_blank" rel="noreferrer"
//             className="hdr-dcontact" onClick={() => setDrawerOpen(false)}>
//             <div className="hdr-dcontact-icon" style={{ background:"rgba(37,211,102,.1)" }}>
//               <FaWhatsapp color="#25D366" size={18} />
//             </div>
//             <div>
//               <div style={{ fontSize:13, fontWeight:700, color:"#222" }}>WhatsApp</div>
//               <div style={{ fontSize:11, color:"#888" }}>+91 8374777834</div>
//             </div>
//           </a>
//         </nav>

//         {/* Footer CTA */}
//         <div className="hdr-drawer-footer">
//           <a href="/locations" className="hdr-dfooter-book" onClick={() => setDrawerOpen(false)}>
//             🎉 Book Your Party Now
//           </a>
//           <p className="hdr-dfooter-sub">Free callback within 2 hours • No obligation</p>
//         </div>
//       </aside>

//       {/* ══ MOBILE BOTTOM NAV ════════════════════════════════════════ */}
//       <nav className="hdr-bottom-nav hdr-mob-only" aria-label="Bottom navigation">
//         {BOTTOM_NAV.slice(0, 2).map(({ to, label, icon: Icon }) => (
//           <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `hdr-bnav-item${isActive ? " active" : ""}`}>
//             {({ isActive }) => (
//               <>
//                 <div className="hdr-bnav-icon"><Icon size={isActive ? 19 : 18} /></div>
//                 {label}
//               </>
//             )}
//           </NavLink>
//         ))}

//         {/* Center Book Now */}
//         <div className="hdr-bnav-center" onClick={() => window.location.href = "/locations"} role="button" tabIndex={0}>
//           <div className="hdr-bnav-center-inner">
//             <FaTicketAlt size={20} color="#fff" />
//           </div>
//           <span>Book Now</span>
//         </div>

//         {BOTTOM_NAV.slice(2).map(({ to, label, icon: Icon }) => (
//           <NavLink key={to} to={to} className={({ isActive }) => `hdr-bnav-item${isActive ? " active" : ""}`}>
//             {({ isActive }) => (
//               <>
//                 <div className="hdr-bnav-icon"><Icon size={isActive ? 19 : 18} /></div>
//                 {label}
//               </>
//             )}
//           </NavLink>
//         ))}
//       </nav>

//       {/* ══ FLOATING ACTIONS ══════════════════════════════════════════ */}
//       <div className="hdr-floating">
//         <button className="hdr-fab hdr-fab-fs" onClick={toggleFS} aria-label="Toggle fullscreen">
//           {isFS ? <FaCompress size={18} color="#fff" /> : <FaExpand size={18} color="#fff" />}
//         </button>
//         <a href="tel:+918341428342" className="hdr-fab hdr-fab-phone" aria-label="Call us">
//           <FaPhoneAlt size={18} color="#fff" />
//         </a>
//         <a href="https://wa.me/918374777834" className="hdr-fab hdr-fab-wa" aria-label="WhatsApp" target="_blank" rel="noreferrer" style={{ position:"relative" }}>
//           <FaWhatsapp size={20} color="#fff" />
//           {showMsg && <div className="hdr-floating-msg">How can I assist you?</div>}
//         </a>
//       </div>
//     </>
//   );
// }

// export default Header;

import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { URLS } from "../Url";
import axios from "axios";
import logo from "./logo1.png";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaPhoneAlt, FaWhatsapp, FaMobileAlt, FaInstagram,
  FaHome, FaMapMarkerAlt, FaBirthdayCake, FaUser,
  FaBars, FaCompress, FaExpand, FaImage, FaDollarSign,
  FaCrown, FaTicketAlt, FaTimes, FaChevronDown,
} from "react-icons/fa";

/* ─── Brand tokens ──────────────────────────────────────────────────────── */
const B = {
  purple:  "#5E0E73",
  purpleL: "#7B1A94",
  purpleD: "#3A0847",
  gold:    "#C9A84C",
  goldL:   "#E8D5A0",
  goldB:   "#F5D87A",
  dark:    "#1A0030",
  cream:   "#E8E1D6",
  white:   "#FFFFFF",
};

const NAV_LINKS = [
  { to: "/",          label: "Home",        icon: "🏠" },
  { to: "/gallery",   label: "Gallery",     icon: "📸" },
 
  { to: "/locations", label: "Decorated Theatres",    icon: "🎬" },
  { to: "/Reviews",   label: "Testimonials",icon: "⭐" },
 
  { to: "/cakes",     label: "Cakes",       icon: "🎂" },
  { to: "/enquiry",   label: "Get Quote",   icon: "💬" },
  
  { to: "/packages",  label: "Plans",       icon: "👑" },
   { to: "/about",     label: "About Us",    icon: "✨" },
];

const OCCASIONS = [
  { to: "/birthday",     label: "Birthday",                 icon: "🎂", desc: "Make birthdays unforgettable" },
  { to: "/kids",         label: "Kids Birthday Celebration",        icon: "🧒", desc: "Fun-filled celebrations for little ones" },
  { to: "/anniversary",  label: "Anniversary",             icon: "💑", desc: "Celebrate love & milestones" },
  { to: "/groom-to-be",  label: "Bride to be",             icon: "🤵", desc: "Bachelor party experiences" },
  
  { to: "/proposals",    label: "Proposals",        icon: "💍", desc: "Say yes in the most magical way" },
];

const BOTTOM_NAV = [
  { to: "/",         label: "Home",    icon: FaHome },
  { to: "/gallery",  label: "Gallery", icon: FaImage },
  { to: "/cakes",    label: "Addons",  icon: FaBirthdayCake },
  { to: "/packages", label: "Plans",   icon: FaCrown },
];

/* ══════════════════════════════════════════════════════════════════════════ */
function Header() {
  const location   = useLocation();
  const [drawerOpen, setDrawerOpen]         = useState(false);
  const [scrolled,   setScrolled]           = useState(false);
  const [showMsg,    setShowMsg]            = useState(false);
  const [isFS,       setIsFS]              = useState(false);
  const [Contact,    setContact]            = useState({});
  const [occDropOpen, setOccDropOpen]       = useState(false);
  const [occDrawerOpen, setOccDrawerOpen]   = useState(false);
  const drawerRef   = useRef(null);
  const occDropRef  = useRef(null);

  /* scroll detection */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* close drawer on route change */
  useEffect(() => {
    setDrawerOpen(false);
    setOccDropOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  /* floating message on home */
  useEffect(() => {
    if (location.pathname === "/") {
      setShowMsg(true);
      const t = setTimeout(() => setShowMsg(false), 15000);
      return () => clearTimeout(t);
    }
  }, [location.pathname]);

  /* fetch contact */
  useEffect(() => {
    axios.post(URLS.GetFooter, {}).then(r => {
      if (r.status === 200) setContact(r.data.contactus?.[0] || {});
    }).catch(() => {});
  }, []);

  /* close drawer on outside click */
  useEffect(() => {
    const handler = e => {
      if (drawerOpen && drawerRef.current && !drawerRef.current.contains(e.target)) {
        setDrawerOpen(false);
      }
      if (occDropOpen && occDropRef.current && !occDropRef.current.contains(e.target)) {
        setOccDropOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [drawerOpen, occDropOpen]);

  /* lock body scroll when drawer open */
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [drawerOpen]);

  const toggleFS = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFS(true);
    } else {
      document.exitFullscreen();
      setIsFS(false);
    }
  };

  const isOccasionActive = OCCASIONS.some(o => location.pathname === o.to);

  return (
    <>
      {/* ══════════════ STYLES ══════════════════════════════════════ */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@400;500;600;700&display=swap');

        :root {
          --hp: ${B.purple}; --hpl: ${B.purpleL}; --hpd: ${B.purpleD};
          --hg: ${B.gold}; --hgl: ${B.goldL}; --hgb: ${B.goldB};
          --hdk: ${B.dark}; --hcr: ${B.cream};
        }

        /* ── Top contact bar ── */
        .hdr-topbar {
          background: linear-gradient(135deg, var(--hpd) 0%, var(--hp) 60%, var(--hpd) 100%);
          padding: 7px 0;
          overflow: hidden;
          position: relative;
          border-bottom: 1px solid rgba(201,168,76,.2);
        }
        .hdr-topbar::before {
          content: '';
          position: absolute; inset: 0;
          background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.03'%3E%3Cpath d='M20 20v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
          pointer-events: none;
        }
        .hdr-topbar-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 8px;
          position: relative;
          z-index: 1;
        }
        .hdr-topbar-left {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: rgba(255,255,255,.75);
          font-family: 'DM Sans', sans-serif;
          font-weight: 500;
        }
        .hdr-topbar-left span {
          background: rgba(201,168,76,.18);
          border: 1px solid rgba(201,168,76,.3);
          border-radius: 60px;
          padding: 3px 12px;
          font-size: 11px;
          color: ${B.goldL};
          font-weight: 700;
          letter-spacing: .5px;
        }
        .hdr-topbar-contacts {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .hdr-tc-link {
          display: flex;
          align-items: center;
          gap: 7px;
          color: rgba(255,255,255,.85);
          text-decoration: none;
          font-size: 12px;
          font-family: 'DM Sans', sans-serif;
          font-weight: 600;
          transition: color .2s;
        }
        .hdr-tc-link:hover { color: ${B.goldL}; }
        .hdr-tc-icon {
          width: 24px; height: 24px; border-radius: 50%;
          background: rgba(255,255,255,.12);
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
          transition: background .2s;
        }
        .hdr-tc-link:hover .hdr-tc-icon { background: rgba(201,168,76,.25); }

        /* ── Main navbar ── */
        .hdr-main {
          position: sticky;
          top: 0;
          z-index: 999;
          background: rgba(255,255,255,0.97);
          border-bottom: 1px solid rgba(94,14,115,.08);
          transition: box-shadow .35s, background .35s, backdrop-filter .35s;
          font-family: 'DM Sans', sans-serif;
        }
        .hdr-main.scrolled {
          background: rgba(255,255,255,0.88);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          box-shadow: 0 4px 32px rgba(94,14,115,.12);
          border-bottom-color: rgba(201,168,76,.2);
        }
        .hdr-main-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 70px;
          gap: 16px;
        }

        /* Logo */
        .hdr-logo {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          text-decoration: none;
          gap: 10px;
        }
        .hdr-logo img {
          height: 52px;
          width: auto;
          display: block;
          transition: transform .3s;
        }
        .hdr-logo:hover img { transform: scale(1.04); }

        /* Desktop Nav Links */
        .hdr-nav-links {
          display: flex;
          align-items: center;
          gap: 2px;
          list-style: none;
          margin: 0; padding: 0;
          flex: 1;
          justify-content: center;
        }
        .hdr-nav-links li a {
          display: inline-flex;
          align-items: center;
          padding: 8px 13px;
          font-size: 13px;
          font-weight: 600;
          color: #444;
          text-decoration: none;
          border-radius: 10px;
          position: relative;
          transition: color .25s, background .25s;
          letter-spacing: .2px;
          white-space: nowrap;
        }
        .hdr-nav-links li a::after {
          content: '';
          position: absolute;
          bottom: 4px; left: 50%;
          width: 0; height: 2px;
          background: linear-gradient(90deg, var(--hp), var(--hg));
          border-radius: 2px;
          transform: translateX(-50%);
          transition: width .3s cubic-bezier(.25,1,.5,1);
        }
        .hdr-nav-links li a:hover { color: var(--hp); background: rgba(94,14,115,.05); }
        .hdr-nav-links li a:hover::after { width: 60%; }
        .hdr-nav-links li a.active {
          color: var(--hp);
          background: rgba(94,14,115,.07);
          font-weight: 700;
        }
        .hdr-nav-links li a.active::after { width: 65%; }

        /* ── OCCASIONS DROPDOWN ── */
        .hdr-occ-wrapper {
          position: relative;
        }
        .hdr-occ-trigger {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 8px 13px;
          font-size: 13px;
          font-weight: 600;
          color: #444;
          background: none;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          font-family: 'DM Sans', sans-serif;
          position: relative;
          transition: color .25s, background .25s;
          letter-spacing: .2px;
          white-space: nowrap;
        }
        .hdr-occ-trigger::after {
          content: '';
          position: absolute;
          bottom: 4px; left: 50%;
          width: 0; height: 2px;
          background: linear-gradient(90deg, var(--hp), var(--hg));
          border-radius: 2px;
          transform: translateX(-50%);
          transition: width .3s cubic-bezier(.25,1,.5,1);
        }
        .hdr-occ-trigger:hover,
        .hdr-occ-trigger.active { color: var(--hp); background: rgba(94,14,115,.05); }
        .hdr-occ-trigger:hover::after,
        .hdr-occ-trigger.active::after { width: 60%; }
        .hdr-occ-trigger.active { background: rgba(94,14,115,.07); font-weight: 700; }
        .hdr-occ-trigger.active::after { width: 65%; }

        .hdr-occ-chevron {
          display: inline-flex;
          align-items: center;
          transition: transform .25s cubic-bezier(.25,1,.5,1);
          opacity: .6;
        }
        .hdr-occ-chevron.open { transform: rotate(180deg); opacity: 1; }

        /* Dropdown panel */
        .hdr-occ-dropdown {
          position: absolute;
          top: calc(100% + 10px);
          left: 50%;
          transform: translateX(-50%) translateY(-6px);
          min-width: 280px;
          background: #fff;
          border-radius: 18px;
          box-shadow: 0 20px 60px rgba(94,14,115,.18), 0 4px 16px rgba(0,0,0,.06);
          border: 1px solid rgba(94,14,115,.08);
          overflow: hidden;
          opacity: 0;
          pointer-events: none;
          transition: opacity .22s ease, transform .22s cubic-bezier(.25,1,.5,1);
          z-index: 1100;
        }
        .hdr-occ-dropdown.open {
          opacity: 1;
          pointer-events: all;
          transform: translateX(-50%) translateY(0);
        }

        /* Dropdown header strip */
        .hdr-occ-drop-head {
          background: linear-gradient(135deg, var(--hpd), var(--hp));
          padding: 14px 18px 12px;
          position: relative;
          overflow: hidden;
        }
        .hdr-occ-drop-head::before {
          content: '';
          position: absolute; inset: 0;
          background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.05'%3E%3Cpath d='M20 20v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
          pointer-events: none;
        }
        .hdr-occ-drop-head-title {
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: rgba(255,255,255,.7);
          font-family: 'DM Sans', sans-serif;
          position: relative;
        }
        .hdr-occ-drop-head-sub {
          font-size: 13px;
          font-weight: 700;
          color: #fff;
          margin-top: 2px;
          font-family: 'DM Sans', sans-serif;
          position: relative;
        }

        /* Dropdown items */
        .hdr-occ-drop-list {
          padding: 8px 0;
        }
        .hdr-occ-drop-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 11px 18px;
          text-decoration: none;
          transition: background .18s;
          border-bottom: 1px solid rgba(94,14,115,.04);
        }
        .hdr-occ-drop-item:last-child { border-bottom: none; }
        .hdr-occ-drop-item:hover { background: rgba(94,14,115,.05); }
        .hdr-occ-drop-item.active { background: rgba(94,14,115,.07); }
        .hdr-occ-drop-emoji {
          width: 38px; height: 38px;
          border-radius: 12px;
          background: rgba(94,14,115,.07);
          display: flex; align-items: center; justify-content: center;
          font-size: 18px;
          flex-shrink: 0;
          transition: background .18s;
        }
        .hdr-occ-drop-item:hover .hdr-occ-drop-emoji,
        .hdr-occ-drop-item.active .hdr-occ-drop-emoji {
          background: linear-gradient(135deg, var(--hp), var(--hpl));
        }
        .hdr-occ-drop-text {}
        .hdr-occ-drop-name {
          font-size: 13px;
          font-weight: 700;
          color: #222;
          font-family: 'DM Sans', sans-serif;
          line-height: 1.2;
        }
        .hdr-occ-drop-item:hover .hdr-occ-drop-name,
        .hdr-occ-drop-item.active .hdr-occ-drop-name { color: var(--hp); }
        .hdr-occ-drop-desc {
          font-size: 11px;
          color: #999;
          font-family: 'DM Sans', sans-serif;
          margin-top: 1px;
        }
        .hdr-occ-drop-arrow {
          margin-left: auto;
          font-size: 14px;
          color: rgba(94,14,115,.25);
          font-weight: 700;
          transition: color .18s, transform .18s;
          flex-shrink: 0;
        }
        .hdr-occ-drop-item:hover .hdr-occ-drop-arrow { color: var(--hp); transform: translateX(3px); }

        /* Desktop right area */
        .hdr-right {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
        }
        .hdr-rewards-btn {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: linear-gradient(135deg, rgba(94,14,115,.08), rgba(94,14,115,.04));
          border: 1.5px solid rgba(94,14,115,.2);
          border-radius: 60px;
          padding: 7px 16px;
          color: var(--hp);
          font-size: 12px;
          font-weight: 700;
          text-decoration: none;
          transition: all .3s;
          letter-spacing: .3px;
        }
        .hdr-rewards-btn:hover {
          background: var(--hp);
          color: #fff;
          border-color: var(--hp);
          transform: translateY(-1px);
          box-shadow: 0 6px 18px rgba(94,14,115,.3);
        }

        /* Book Now CTA */
        .hdr-book-btn {
          position: relative;
          overflow: hidden;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          background: linear-gradient(135deg, #B8860B, var(--hg), var(--hgb), var(--hg), #9A6E10);
          background-size: 200% 200%;
          animation: hdrGold 3s ease infinite;
          color: var(--hdk);
          border: none;
          border-radius: 60px;
          padding: 10px 22px;
          font-size: 13px;
          font-weight: 800;
          cursor: pointer;
          text-decoration: none;
          transition: transform .3s, box-shadow .3s;
          box-shadow: 0 5px 18px rgba(201,168,76,.4);
          font-family: 'DM Sans', sans-serif;
          letter-spacing: .3px;
          white-space: nowrap;
        }
        .hdr-book-btn::before {
          content: '';
          position: absolute; top: 0; left: -100%;
          width: 55%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
          animation: hdrShine 3s ease infinite;
        }
        .hdr-book-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 28px rgba(201,168,76,.55);
          color: var(--hdk);
        }
        @keyframes hdrGold  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
        @keyframes hdrShine { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
        @keyframes hdrFade  { from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)} }
        @keyframes hdrSlide { from{transform:translateX(-100%)}to{transform:translateX(0)} }
        @keyframes hdrPulse { 0%,100%{box-shadow:0 0 0 0 rgba(201,168,76,.4)}50%{box-shadow:0 0 0 8px rgba(201,168,76,0)} }

        /* ── MOBILE TOP BAR ── */
        .hdr-mobile-bar {
          display: none;
          height: 64px;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px;
        }
        @media(max-width:991px) {
          .hdr-main-inner { display: none; }
          .hdr-mobile-bar { display: flex; }
          .hdr-topbar { display: none; }
        }
        .hdr-mob-hamburger {
          width: 40px; height: 40px;
          border-radius: 12px;
          background: rgba(94,14,115,.08);
          border: 1.5px solid rgba(94,14,115,.15);
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          gap: 5px; cursor: pointer;
          transition: all .25s; flex-shrink: 0;
        }
        .hdr-mob-hamburger:hover { background: var(--hp); border-color: var(--hp); }
        .hdr-mob-hamburger:hover .hdr-ham-line { background: #fff; }
        .hdr-ham-line { width: 20px; height: 2px; background: var(--hp); border-radius: 2px; transition: background .25s; }

        .hdr-mob-right {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .hdr-mob-rewards {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: rgba(94,14,115,.07);
          border: 1.5px solid rgba(94,14,115,.2);
          border-radius: 60px;
          padding: 6px 13px;
          color: var(--hp);
          font-size: 12px;
          font-weight: 700;
          text-decoration: none;
        }
        .hdr-mob-book {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: linear-gradient(135deg, var(--hp), var(--hpl));
          color: #fff;
          border: none;
          border-radius: 60px;
          padding: 7px 16px;
          font-size: 12px;
          font-weight: 700;
          cursor: pointer;
          text-decoration: none;
          box-shadow: 0 4px 12px rgba(94,14,115,.3);
          font-family: 'DM Sans', sans-serif;
        }

        /* ── DRAWER OVERLAY ── */
        .hdr-overlay {
          position: fixed; inset: 0; z-index: 1400;
          background: rgba(10,0,20,.55);
          backdrop-filter: blur(4px);
          opacity: 0; pointer-events: none;
          transition: opacity .35s;
        }
        .hdr-overlay.open { opacity: 1; pointer-events: all; }

        /* ── DRAWER ── */
        .hdr-drawer {
          position: fixed;
          top: 0; left: 0; bottom: 0;
          width: min(340px, 88vw);
          z-index: 1500;
          background: #fff;
          transform: translateX(-100%);
          transition: transform .38s cubic-bezier(.25,1,.5,1);
          display: flex;
          flex-direction: column;
          overflow: hidden;
          box-shadow: 8px 0 60px rgba(94,14,115,.2);
        }
        .hdr-drawer.open {
          transform: translateX(0);
        }

        /* Drawer header */
        .hdr-drawer-head {
          background: linear-gradient(135deg, var(--hpd) 0%, var(--hp) 100%);
          padding: 24px 20px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-shrink: 0;
          position: relative;
          overflow: hidden;
        }
        .hdr-drawer-head::before {
          content: '';
          position: absolute; inset: 0;
          background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
          pointer-events: none;
        }
        .hdr-drawer-logo { height: 48px; width: auto; position: relative; z-index: 1; }
        .hdr-drawer-close {
          width: 36px; height: 36px; border-radius: 50%;
          background: rgba(255,255,255,.15);
          border: 1.5px solid rgba(255,255,255,.25);
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; color: #fff; font-size: 16px;
          transition: all .25s; position: relative; z-index: 1;
        }
        .hdr-drawer-close:hover { background: rgba(255,255,255,.28); }

        /* Drawer gold strip */
        .hdr-drawer-gold {
          background: linear-gradient(135deg, #B8860B, var(--hg), var(--hgb), var(--hg));
          background-size: 200% 200%;
          animation: hdrGold 3s ease infinite;
          padding: 10px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-shrink: 0;
        }
        .hdr-drawer-gold-text {
          font-size: 12px;
          font-weight: 800;
          color: var(--hdk);
          letter-spacing: .5px;
        }
        .hdr-drawer-gold-code {
          background: rgba(0,0,0,.18);
          border-radius: 6px;
          padding: 3px 10px;
          font-size: 11px;
          font-weight: 800;
          color: var(--hdk);
          font-family: monospace;
          letter-spacing: 1px;
        }

        /* Drawer nav list */
        .hdr-drawer-nav {
          flex: 1;
          overflow-y: auto;
          padding: 12px 0;
        }
        .hdr-drawer-nav::-webkit-scrollbar { width: 3px; }
        .hdr-drawer-nav::-webkit-scrollbar-thumb { background: rgba(94,14,115,.2); border-radius: 2px; }

        .hdr-dlink {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 13px 20px;
          color: #333;
          text-decoration: none;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          transition: all .22s;
          position: relative;
          border-bottom: 1px solid rgba(94,14,115,.04);
        }
        .hdr-dlink:hover { background: rgba(94,14,115,.05); color: var(--hp); padding-left: 26px; }
        .hdr-dlink.active { background: rgba(94,14,115,.07); color: var(--hp); }
        .hdr-dlink.active::before {
          content: '';
          position: absolute; left: 0; top: 0; bottom: 0;
          width: 3px;
          background: linear-gradient(180deg, var(--hp), var(--hg));
          border-radius: 0 2px 2px 0;
        }
        .hdr-dlink-icon {
          width: 38px; height: 38px;
          border-radius: 12px;
          background: rgba(94,14,115,.07);
          display: flex; align-items: center; justify-content: center;
          font-size: 17px;
          flex-shrink: 0;
          transition: background .22s;
        }
        .hdr-dlink:hover .hdr-dlink-icon,
        .hdr-dlink.active .hdr-dlink-icon {
          background: linear-gradient(135deg, var(--hp), var(--hpl));
          font-size: 17px;
        }
        .hdr-dlink-arrow {
          margin-left: auto;
          font-size: 11px;
          color: rgba(94,14,115,.3);
          transition: color .22s, transform .22s;
        }
        .hdr-dlink:hover .hdr-dlink-arrow { color: var(--hp); transform: translateX(3px); }

        /* Drawer section label */
        .hdr-dsection {
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: rgba(94,14,115,.45);
          padding: 16px 20px 6px;
          font-family: 'DM Sans', sans-serif;
        }

        /* ── DRAWER OCCASIONS ACCORDION ── */
        .hdr-docc-trigger {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 13px 20px;
          color: #333;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          transition: all .22s;
          position: relative;
          border-bottom: 1px solid rgba(94,14,115,.04);
          cursor: pointer;
          background: none;
          border-left: none;
          border-right: none;
          border-top: none;
          width: 100%;
          text-align: left;
        }
        .hdr-docc-trigger:hover { background: rgba(94,14,115,.05); color: var(--hp); }
        .hdr-docc-trigger.active-section { background: rgba(94,14,115,.07); color: var(--hp); }
        .hdr-docc-trigger.active-section::before {
          content: '';
          position: absolute; left: 0; top: 0; bottom: 0;
          width: 3px;
          background: linear-gradient(180deg, var(--hp), var(--hg));
          border-radius: 0 2px 2px 0;
        }
        .hdr-docc-chevron {
          margin-left: auto;
          display: inline-flex;
          align-items: center;
          color: rgba(94,14,115,.3);
          transition: transform .25s cubic-bezier(.25,1,.5,1), color .22s;
        }
        .hdr-docc-chevron.open { transform: rotate(180deg); color: var(--hp); }

        .hdr-docc-panel {
          overflow: hidden;
          max-height: 0;
          transition: max-height .35s cubic-bezier(.25,1,.5,1);
          background: rgba(94,14,115,.02);
          border-bottom: 1px solid rgba(94,14,115,.06);
        }
        .hdr-docc-panel.open { max-height: 400px; }

        .hdr-docc-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 11px 20px 11px 28px;
          color: #444;
          text-decoration: none;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 600;
          border-bottom: 1px solid rgba(94,14,115,.04);
          transition: background .18s, color .18s;
        }
        .hdr-docc-item:last-child { border-bottom: none; }
        .hdr-docc-item:hover { background: rgba(94,14,115,.06); color: var(--hp); }
        .hdr-docc-item.active { color: var(--hp); background: rgba(94,14,115,.08); font-weight: 700; }
        .hdr-docc-item-emoji {
          width: 32px; height: 32px;
          border-radius: 10px;
          background: rgba(94,14,115,.06);
          display: flex; align-items: center; justify-content: center;
          font-size: 15px;
          flex-shrink: 0;
          transition: background .18s;
        }
        .hdr-docc-item:hover .hdr-docc-item-emoji,
        .hdr-docc-item.active .hdr-docc-item-emoji {
          background: linear-gradient(135deg, var(--hp), var(--hpl));
        }

        /* Drawer contact items */
        .hdr-dcontact {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 12px 20px;
          color: #444;
          text-decoration: none;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 500;
          border-bottom: 1px solid rgba(94,14,115,.04);
          transition: background .2s;
        }
        .hdr-dcontact:hover { background: rgba(94,14,115,.04); }
        .hdr-dcontact-icon {
          width: 36px; height: 36px; border-radius: 10px;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }

        /* Drawer footer */
        .hdr-drawer-footer {
          padding: 16px 20px;
          border-top: 1px solid rgba(94,14,115,.08);
          flex-shrink: 0;
        }
        .hdr-dfooter-book {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          padding: 14px;
          background: linear-gradient(135deg, var(--hp), var(--hpl));
          color: #fff;
          border: none;
          border-radius: 16px;
          font-size: 15px;
          font-weight: 800;
          cursor: pointer;
          text-decoration: none;
          box-shadow: 0 8px 24px rgba(94,14,115,.35);
          transition: all .3s;
          font-family: 'DM Sans', sans-serif;
        }
        .hdr-dfooter-book:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(94,14,115,.45);
          color: #fff;
        }
        .hdr-dfooter-sub {
          text-align: center;
          font-size: 11px;
          color: #aaa;
          margin-top: 8px;
          font-family: 'DM Sans', sans-serif;
        }

        /* ── MOBILE BOTTOM NAV ── */
        .hdr-bottom-nav {
          position: fixed;
          bottom: 0; left: 0; right: 0;
          height: 62px;
          background: rgba(255,255,255,.96);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border-top: 1px solid rgba(94,14,115,.1);
          display: none;
          justify-content: space-around;
          align-items: center;
          z-index: 1000;
          padding-bottom: env(safe-area-inset-bottom, 0px);
          box-shadow: 0 -4px 24px rgba(94,14,115,.08);
        }
        @media(max-width:991px) { .hdr-bottom-nav { display: flex; } }

        .hdr-bnav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3px;
          color: #999;
          text-decoration: none;
          font-size: 10px;
          font-weight: 600;
          font-family: 'DM Sans', sans-serif;
          transition: color .25s;
          padding: 6px 12px;
          border-radius: 14px;
          min-width: 56px;
        }
        .hdr-bnav-item:hover { color: var(--hp); }
        .hdr-bnav-item.active { color: var(--hp); }
        .hdr-bnav-icon {
          width: 28px; height: 28px;
          display: flex; align-items: center; justify-content: center;
          border-radius: 10px;
          transition: background .25s, transform .25s;
          font-size: 17px;
        }
        .hdr-bnav-item.active .hdr-bnav-icon {
          background: rgba(94,14,115,.1);
          transform: translateY(-1px);
        }

        /* Center Book button */
        .hdr-bnav-center {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3px;
          cursor: pointer;
          margin-top: -22px;
        }
        .hdr-bnav-center-inner {
          width: 54px; height: 54px;
          border-radius: 50%;
          background: linear-gradient(135deg, var(--hp), var(--hpl));
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 6px 20px rgba(94,14,115,.45);
          border: 3px solid #fff;
          transition: all .3s;
          animation: hdrPulse 2.5s ease-in-out infinite;
        }
        .hdr-bnav-center:hover .hdr-bnav-center-inner {
          transform: scale(1.08);
          box-shadow: 0 10px 28px rgba(94,14,115,.55);
        }
        .hdr-bnav-center span {
          font-size: 10px; font-weight: 700;
          color: var(--hp); font-family: 'DM Sans', sans-serif;
          margin-top: 2px;
        }

        /* ── FLOATING ACTIONS ── */
        .hdr-floating {
          position: fixed;
          bottom: 80px; right: 18px;
          z-index: 998;
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: center;
        }
        @media(max-width:991px) { .hdr-floating { bottom: 80px; } }
        .hdr-fab {
          width: 48px; height: 48px;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: all .3s;
          box-shadow: 0 4px 14px rgba(0,0,0,.2);
        }
        .hdr-fab:hover { transform: translateY(-3px) scale(1.08); }
        .hdr-fab-fs     { background: var(--hp); }
        .hdr-fab-phone  { background: #242724; }
        .hdr-fab-wa     { background: #25D366; }
        .hdr-fab-wa:hover { box-shadow: 0 6px 20px rgba(37,211,102,.4); }
        .hdr-fab-phone:hover { box-shadow: 0 6px 20px rgba(36,39,36,.4); }
        .hdr-fab-fs:hover { box-shadow: 0 6px 20px rgba(94,14,115,.4); }

        .hdr-floating-msg {
          position: absolute;
          right: 58px; bottom: 4px;
          background: #fff;
          padding: 7px 14px;
          border-radius: 10px;
          box-shadow: 0 4px 16px rgba(0,0,0,.1);
          white-space: nowrap;
          font-size: 12px;
          font-weight: 600;
          color: #333;
          font-family: 'DM Sans', sans-serif;
          border: 1px solid rgba(94,14,115,.1);
          animation: hdrFade .4s ease both;
        }
        .hdr-floating-msg::after {
          content: '';
          position: absolute; right: -7px; top: 50%;
          transform: translateY(-50%);
          border: 6px solid transparent;
          border-left-color: #fff;
        }

        /* ── Responsive hide/show ── */
        @media(min-width:992px) {
          .hdr-mob-only { display: none !important; }
        }
        @media(max-width:991px) {
          .hdr-desk-only { display: none !important; }
          body { padding-bottom: 68px; }
        }

        /* Adjust so nav underline works with NavLink active */
        .hdr-nav-links li a.active-link { color: var(--hp) !important; background: rgba(94,14,115,.07) !important; font-weight: 700 !important; }
        .hdr-nav-links li a.active-link::after { width: 65% !important; }
      `}</style>

      {/* ══ TOP CONTACT BAR (desktop only) ══════════════════════════ */}
      <div className="hdr-topbar hdr-desk-only">
        <div className="container">
          <div className="hdr-topbar-inner">
            <div className="hdr-topbar-left">
              <span>🎉 Book Now</span>
              <span style={{ fontSize:12, color:"rgba(255,255,255,.6)", background:"none", border:"none", padding:0 }}>& get up to 300 off with code</span>
              <span>CC300</span>
            </div>
            <div className="hdr-topbar-contacts">
              <a href="https://www.instagram.com/carnival_castle_/" target="_blank" rel="noreferrer" className="hdr-tc-link">
                <span className="hdr-tc-icon"><FaInstagram color="#E1306C" size={12} /></span>
                carnival_castle
              </a>
              <a href="tel:8341428342" className="hdr-tc-link">
                <span className="hdr-tc-icon"><FaPhoneAlt color={B.gold} size={11} /></span>
                +91 8341428342
              </a>
              <a href="https://wa.me/918374777834" target="_blank" rel="noreferrer" className="hdr-tc-link">
                <span className="hdr-tc-icon"><FaWhatsapp color="#25D366" size={13} /></span>
                +91 8341428342
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ══ MAIN NAVBAR ══════════════════════════════════════════════ */}
      <header className={`hdr-main${scrolled ? " scrolled" : ""}`}>
        {/* ── Desktop ── */}
        <div className="container hdr-desk-only">
          <div className="hdr-main-inner">
            <a href="/" className="hdr-logo">
              <img src={logo} alt="Carnival Castle" />
            </a>

            <ul className="hdr-nav-links">
              {NAV_LINKS.slice(0, 8).map(({ to, label }) => (
                <li key={to}>
                  <NavLink
                    to={to}
                    className={({ isActive }) => isActive ? "active-link" : ""}
                    end={to === "/"}
                  >
                    {label}
                  </NavLink>
                </li>
              ))}

              {/* ── Occasions Dropdown ── */}
              <li ref={occDropRef} className="hdr-occ-wrapper">
                <button
                  className={`hdr-occ-trigger${isOccasionActive ? " active" : ""}`}
                  onClick={() => setOccDropOpen(v => !v)}
                  aria-haspopup="true"
                  aria-expanded={occDropOpen}
                >
                  Occasions
                  <span className={`hdr-occ-chevron${occDropOpen ? " open" : ""}`}>
                    <FaChevronDown size={10} />
                  </span>
                </button>

                <div className={`hdr-occ-dropdown${occDropOpen ? " open" : ""}`} role="menu">
                  <div className="hdr-occ-drop-head">
                    <div className="hdr-occ-drop-head-title">Celebrate With Us</div>
                    <div className="hdr-occ-drop-head-sub">Choose Your Occasion 🎊</div>
                  </div>
                  <div className="hdr-occ-drop-list">
                    {OCCASIONS.map(({ to, label, icon, desc }) => (
                      <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) => `hdr-occ-drop-item${isActive ? " active" : ""}`}
                        onClick={() => setOccDropOpen(false)}
                        role="menuitem"
                      >
                        <div className="hdr-occ-drop-emoji">{icon}</div>
                        <div className="hdr-occ-drop-text">
                          <div className="hdr-occ-drop-name">{label}</div>
                          <div className="hdr-occ-drop-desc">{desc}</div>
                        </div>
                        <span className="hdr-occ-drop-arrow">›</span>
                      </NavLink>
                    ))}
                  </div>
                </div>
              </li>
            </ul>

            <div className="hdr-right">
              <a href="/profile" className="hdr-rewards-btn">
                <i className="bi bi-gift-fill" style={{ fontSize:13 }} />
                Rewards
              </a>
              <a href="/locations" className="hdr-book-btn">
                🎉 Book Now
              </a>
            </div>
          </div>
        </div>

        {/* ── Mobile top bar ── */}
        <div className="hdr-mobile-bar hdr-mob-only">
          <button className="hdr-mob-hamburger" onClick={() => setDrawerOpen(true)} aria-label="Open menu">
            <div className="hdr-ham-line" />
            <div className="hdr-ham-line" />
            <div className="hdr-ham-line" style={{ width:14 }} />
          </button>

          <a href="/" className="hdr-logo">
            <img src={logo} alt="Carnival Castle" style={{ height:46 }} />
          </a>

          <div className="hdr-mob-right">
            <a href="/profile" className="hdr-mob-rewards">
              <i className="bi bi-gift-fill" style={{ fontSize:12 }} />
              Rewards
            </a>
            <a href="/locations" className="hdr-mob-book">
              🎉 Book
            </a>
          </div>
        </div>
      </header>

      {/* ══ DRAWER OVERLAY ═══════════════════════════════════════════ */}
      <div className={`hdr-overlay hdr-mob-only${drawerOpen ? " open" : ""}`} onClick={() => setDrawerOpen(false)} />

      {/* ══ DRAWER ═══════════════════════════════════════════════════ */}
      <aside ref={drawerRef} className={`hdr-drawer hdr-mob-only${drawerOpen ? " open" : ""}`} aria-hidden={!drawerOpen}>
        {/* Header */}
        <div className="hdr-drawer-head">
          <img src={logo} alt="Logo" className="hdr-drawer-logo" />
          <button className="hdr-drawer-close" onClick={() => setDrawerOpen(false)} aria-label="Close menu">
            <FaTimes size={14} />
          </button>
        </div>

        {/* Gold promo strip */}
        <div className="hdr-drawer-gold">
          <span className="hdr-drawer-gold-text">🎁 Up to 40% OFF Today</span>
          <span className="hdr-drawer-gold-code">CASTLE10</span>
        </div>

        {/* Nav links */}
        <nav className="hdr-drawer-nav">
          <div className="hdr-dsection">Navigation</div>
          {NAV_LINKS.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className={({ isActive }) => `hdr-dlink${isActive ? " active" : ""}`}
              onClick={() => setDrawerOpen(false)}
            >
              <div className="hdr-dlink-icon">{icon}</div>
              <span>{label}</span>
              <span className="hdr-dlink-arrow">›</span>
            </NavLink>
          ))}

          {/* ── Occasions Accordion in Drawer ── */}
          <button
            className={`hdr-docc-trigger${isOccasionActive ? " active-section" : ""}`}
            onClick={() => setOccDrawerOpen(v => !v)}
          >
            <div className="hdr-dlink-icon">🎊</div>
            <span>Occasions</span>
            <span className={`hdr-docc-chevron${occDrawerOpen ? " open" : ""}`}>
              <FaChevronDown size={11} />
            </span>
          </button>
          <div className={`hdr-docc-panel${occDrawerOpen ? " open" : ""}`}>
            {OCCASIONS.map(({ to, label, icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) => `hdr-docc-item${isActive ? " active" : ""}`}
                onClick={() => setDrawerOpen(false)}
              >
                <div className="hdr-docc-item-emoji">{icon}</div>
                <span>{label}</span>
                <span style={{ marginLeft:"auto", fontSize:13, color:"rgba(94,14,115,.3)" }}>›</span>
              </NavLink>
            ))}
          </div>

          {/* Connect section */}
          <div className="hdr-dsection" style={{ marginTop:8 }}>Connect With Us</div>

          <a href="https://www.instagram.com/carnival_castle_/" target="_blank" rel="noreferrer"
            className="hdr-dcontact" onClick={() => setDrawerOpen(false)}>
            <div className="hdr-dcontact-icon" style={{ background:"rgba(225,48,108,.1)" }}>
              <FaInstagram color="#E1306C" size={17} />
            </div>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:"#222" }}>Instagram</div>
              <div style={{ fontSize:11, color:"#888" }}>@carnival_castle</div>
            </div>
          </a>

          <a href="tel:8341428342" className="hdr-dcontact" onClick={() => setDrawerOpen(false)}>
            <div className="hdr-dcontact-icon" style={{ background:"rgba(94,14,115,.08)" }}>
              <FaPhoneAlt color={B.purple} size={15} />
            </div>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:"#222" }}>Call Us</div>
              <div style={{ fontSize:11, color:"#888" }}>+91 8341428342</div>
            </div>
          </a>

          <a href="https://wa.me/918341428342" target="_blank" rel="noreferrer"
            className="hdr-dcontact" onClick={() => setDrawerOpen(false)}>
            <div className="hdr-dcontact-icon" style={{ background:"rgba(37,211,102,.1)" }}>
              <FaWhatsapp color="#25D366" size={18} />
            </div>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:"#222" }}>WhatsApp</div>
              <div style={{ fontSize:11, color:"#888" }}>+91 8341428342</div>
            </div>
          </a>
        </nav>

        {/* Footer CTA */}
        <div className="hdr-drawer-footer">
          <a href="/locations" className="hdr-dfooter-book" onClick={() => setDrawerOpen(false)}>
            🎉 Book Your Party Now
          </a>
          <p className="hdr-dfooter-sub">Free callback within 2 hours • No obligation</p>
        </div>
      </aside>

      {/* ══ MOBILE BOTTOM NAV ════════════════════════════════════════ */}
      <nav className="hdr-bottom-nav hdr-mob-only" aria-label="Bottom navigation">
        {BOTTOM_NAV.slice(0, 2).map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `hdr-bnav-item${isActive ? " active" : ""}`}>
            {({ isActive }) => (
              <>
                <div className="hdr-bnav-icon"><Icon size={isActive ? 19 : 18} /></div>
                {label}
              </>
            )}
          </NavLink>
        ))}

        {/* Center Book Now */}
        <div className="hdr-bnav-center" onClick={() => window.location.href = "/locations"} role="button" tabIndex={0}>
          <div className="hdr-bnav-center-inner">
            <FaTicketAlt size={20} color="#fff" />
          </div>
          <span>Book Now</span>
        </div>

        {BOTTOM_NAV.slice(2).map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} className={({ isActive }) => `hdr-bnav-item${isActive ? " active" : ""}`}>
            {({ isActive }) => (
              <>
                <div className="hdr-bnav-icon"><Icon size={isActive ? 19 : 18} /></div>
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* ══ FLOATING ACTIONS ══════════════════════════════════════════ */}
      <div className="hdr-floating">
        <button className="hdr-fab hdr-fab-fs" onClick={toggleFS} aria-label="Toggle fullscreen">
          {isFS ? <FaCompress size={18} color="#fff" /> : <FaExpand size={18} color="#fff" />}
        </button>
        <a href="tel:+918341428342" className="hdr-fab hdr-fab-phone" aria-label="Call us">
          <FaPhoneAlt size={18} color="#fff" />
        </a>
        <a href="https://wa.me/918341428342" className="hdr-fab hdr-fab-wa" aria-label="WhatsApp" target="_blank" rel="noreferrer" style={{ position:"relative" }}>
          <FaWhatsapp size={20} color="#fff" />
          {showMsg && <div className="hdr-floating-msg">How can I assist you?</div>}
        </a>
      </div>
    </>
  );
}

export default Header;